module.exports = {
	fields: ['name', 'user.firstName', 'user.lastName', 'user.email', 'user.phoneNumber', 'cltv', 'createdAt',
		'country', 'marketSector', 'email', 'atecoCode', 'revenue', 'vat', 'website']
};
